/// <amd-module name="SuiteCommerce.GiftCertificate.PLP"/>
define("SuiteCommerce.GiftCertificate.PLP", ["require", "exports", "SuiteCommerce.GiftCertificate.OptionTiles.Configuration", "SuiteCommerce.GiftCertificate.PLP.Group.View", "SuiteCommerce.GiftCertificate.Group.Collection", "SuiteCommerce.GiftCertificate.Instrumentation"], function (require, exports, OptionTiles_Configuration_1, PLP_Group_View_1, Group_Collection_1, Instrumentation_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            if (OptionTiles_Configuration_1.OptionTilesConfiguration.groupCertificatesAsItemOptions) {
                var PLP = container.getComponent('PLP');
                var groupsCollection = this.getGroups(PLP);
                var environment = container.getComponent('Environment');
                this.addPLPChildView(PLP, groupsCollection, environment);
            }
        },
        getGroups: function (PLP) {
            var _this = this;
            var groupsCollection = new Group_Collection_1.GroupCollection();
            PLP.on('beforeShowContent', function () { return groupsCollection.fetch().done(function () {
                groupsCollection.each(function (group) {
                    _this.registerLogForGiftCertificatesInGroup(group);
                });
            }); });
            return groupsCollection;
        },
        registerLogForGiftCertificatesInGroup: function (group) {
            if (group.giftCertificates.size() > 0) {
                var giftCertificatesByGroupLog = Instrumentation_1.default.getLog('giftCertificatesByGroupLog');
                giftCertificatesByGroupLog.setParameters({
                    activity: 'Gift Certificates quantity by group',
                    instanceCount: group.giftCertificates.size(),
                });
                giftCertificatesByGroupLog.submit();
            }
        },
        addPLPChildView: function (PLP, groupsCollection, environment) {
            PLP.addChildView('StockDescription', function () {
                return new PLP_Group_View_1.PLPGroupView({
                    PLP: PLP,
                    groupsCollection: groupsCollection,
                    environment: environment,
                });
            });
        },
    };
});
